import { react2angular } from 'react2angular';
import { CreateAlarmRuleModal } from './CreateAlarmRuleModal';
import { EditAlarmRuleModal } from './EditAlarmRuleModal';

angular.module('webtip.module')
  .component('alarmRuleCreateModal', react2angular(CreateAlarmRuleModal, [
    'currentFilters', 'criteriaSummary', 'initialFormValues', 'onSaved', 'onCancel',
  ], ['alarmRuleService', 'accountService', 'alarmNotificationService']))
  .component('alarmRuleEditModal', react2angular(EditAlarmRuleModal, [
    'rule', 'onSaved', 'onCancel',
  ], ['alarmRuleService', 'alarmRuleReportService', 'analysisService', 'fleetService', 'accountService', 'alarmNotificationService', '__env']))
  .component('alarmRuleCreateDialog', {
    bindings: { resolve: '<', close: '&', dismiss: '&' },
    template: '<alarm-rule-create-modal current-filters="$ctrl.resolve.currentFilters" criteria-summary="$ctrl.resolve.criteriaSummary" initial-form-values="$ctrl.resolve.initialFormValues" on-saved="$ctrl.close" on-cancel="$ctrl.dismiss"></alarm-rule-create-modal>',
  })
  .component('alarmRuleEditDialog', {
    bindings: { resolve: '<', close: '&', dismiss: '&' },
    template: '<alarm-rule-edit-modal rule="$ctrl.resolve.rule" on-saved="$ctrl.close" on-cancel="$ctrl.dismiss"></alarm-rule-edit-modal>',
  });